import React, { Fragment } from "react";
import { Tooltip, Button, Space } from "antd";
import styles from "../topology.module.scss";
import { RiSettings5Line } from "react-icons/ri";
import { MdDevicesOther } from "react-icons/md";
import { FiMapPin } from "react-icons/fi";
import { BsFileEarmark } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import {
  setDeviceRecord,
  setAlarmTableVisible,
  setDeviceStateVisible,
  setIoTVisible,
  setMapVisible,
  setTab,
  setDeviceIdToGetConfig,
  setFileNameToGetConfig,
  setImportSource,
} from "../store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useGetSchemeList } from "Components/Management/queries";
import { healthIcon, strengthIcon, titleCase } from "./utils";
import { TableData } from "Utility/Types/status_identity_get_set";
import { MdSettingsEthernet } from "react-icons/md";
const Icons = React.memo(
  ({ record, index, exclude }: { record: TableData; index: number; exclude?: undefined | "state" | "others" }) => {
    const { t } = useTranslation();
    const disp = useAppDispatch();
    const { stateCid, level, loginCid, isLogin } = useAppSelector((state) => state.global);
    const { data: userScheme } = useGetSchemeList(stateCid, loginCid, level, isLogin);
    return (
      <Space style={{ rowGap: "1px", columnGap: "1px", paddingLeft: "8px", paddingRight: "8px" }}>
        {!(exclude === "state") && (
          <Fragment>
            <Tooltip title={`${t("ISMS.health")}: ${titleCase(record.health)}`}>
              <Button
                className={styles.Button}
                type="text"
                key={index}
                onClick={() => {
                  disp(setAlarmTableVisible(true));
                  disp(setDeviceRecord(record));
                }}
                icon={healthIcon(record.health)}
              ></Button>
            </Tooltip>
            <Tooltip title={record.strength === null ? "NA" : titleCase(record.strength)}>
              <Button
                className={styles.Button}
                type="text"
                key={index}
                icon={
                  record.strength !== "na" && record.strength !== null ? (
                    strengthIcon(record.strength)
                  ) : (
                    <MdSettingsEthernet />
                  )
                }
              ></Button>
            </Tooltip>
          </Fragment>
        )}

        {!(exclude === "others") && (
          <Fragment>
            <Tooltip title={t("ISMS.DeviceStatus")}>
              <Button
                className={styles.Button}
                type="text"
                key={index}
                onClick={() => {
                  disp(setDeviceStateVisible(true));
                  disp(setDeviceRecord(record));
                }}
                icon={<BsFileEarmark />}
              ></Button>
            </Tooltip>
            <Tooltip title={t("ISMS.Map")}>
              <Button
                className={styles.Button}
                type="text"
                key={index}
                onClick={() => {
                  disp(setMapVisible(true));
                  disp(setDeviceRecord(record));
                }}
                icon={<FiMapPin />}
              ></Button>
            </Tooltip>
            <Tooltip title={t("ISMS.ViewIoT")}>
              <Button
                className={styles.Button}
                // style={
                //   userScheme?.permission_viewFlowData || (level === "super_super" && stateCid === "")
                //     ? {}
                //     : { display: "none" }
                // }
                type="text"
                key={index}
                onClick={() => {
                  disp(setIoTVisible(true));
                  disp(setDeviceRecord(record));
                }}
                icon={<MdDevicesOther />}
              ></Button>
            </Tooltip>
            <Tooltip title={record.health === "offline" ? t("ISMS.Setting(Offline)") : t("ISMS.Setting")}>
              <Button
                className={record.health === "offline" ? styles.Offline_Button : styles.Button}
                type="text"
                key={index}
                // style={{ position: "relative" }}
                onClick={() => {
                  if (record.health === "offline") {
                    return;
                  }
                  disp(setTab("3"));
                  disp(setFileNameToGetConfig(undefined));
                  disp(setDeviceIdToGetConfig(record.id));
                  disp(setImportSource("Device"));
                }}
                icon={<RiSettings5Line />}
                disabled={record.health === "offline"}
              ></Button>
            </Tooltip>
          </Fragment>
        )}
      </Space>
    );
  }
);

export default Icons;
